module.exports = __webpack_public_path__ + "img/wrzl1.53c80e75.webp";